import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Icon } from 'ui';
import { hasPermission, hasEditSmartGroupsPermissions } from '../../selectors';
import PeopleHeaderButtons from './PeopleHeaderButtons';
import Breadcrumbs from './organization/Breadcrumbs';

/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

// $screen-sm size from stylesheets/variables.scss
const SCREEN_SM_SIZE = 768;

class PeopleHeader extends React.Component {
  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    const { groupsListVisible } = this.props;
    // If the group list is visible on a smaller window size (mobile layout),
    // and it was resized to the desktop layout we close the modal and revert
    // scrolling to its normal behavior.
    if (groupsListVisible && window.innerWidth >= SCREEN_SM_SIZE) {
      this.toggleGroupsList();
    }
  };

  toggleGroupsList = () => {
    if (this.props.groupsListVisible) {
      document.body.style.overflow = 'visible';
    } else {
      document.body.style.overflow = 'hidden';
      document.body.style.height = '100vh';
    }
    this.props.toggleGroupsList();
  };

  render() {
    const {
      activeGroupCalculating,
      activeGroupRecalculationState,
      activeGroupName,
      activeGroupId,
      activeGroupType,
      activeGroupCount,
      canEditSmartGroups,
      canManageAllGroups,
      createNewRuleBasedGroup,
      editRuleBasedGroup,
      isFetching,
      groupsListVisible,
      hasManagedGroups,
    } = this.props;
    const headerStyles = classNames('PeopleHeader', {
      'd-f jc-sb ai-c':
        !canManageAllGroups && !activeGroupId && !groupsListVisible,
    });
    const titleStyles = classNames('Index-title', {
      'Index-title--active d-f ai-c': groupsListVisible,
    });
    const isSystemGeneratedGroup = activeGroupType === 'Group::SystemGenerated';

    const title = (
      <span className="PeopleHeader-titleText">
        {activeGroupName || t('groups.everyone.name')}{' '}
        {!activeGroupCalculating && !isFetching && `(${activeGroupCount})`}
      </span>
    );

    return (
      <div className={headerStyles}>
        {activeGroupRecalculationState === 'invalid' && !groupsListVisible && (
          <div className="ErrorContainer ErrorContainer--brandRed d-ib mt-4 mh-34">
            <Icon name="warning_sign" className="mr-4" />
            {canEditSmartGroups
              ? t('smart_groups.blank_slates.invalid.description') +
                ' ' +
                t('smart_groups.blank_slates.invalid.description_2')
              : t('smart_groups.blank_slates.invalid.description')}
            {canEditSmartGroups && (
              // eslint-disable-next-line jsx-a11y/click-events-have-key-events
              <span
                className="td-u ml-4"
                onClick={e => editRuleBasedGroup(activeGroupId)}
              >
                Edit Rules
              </span>
            )}
          </div>
        )}
        {isSystemGeneratedGroup && <Breadcrumbs />}
        <h1 className={classNames(titleStyles, 'u-hideBelowSM')}>{title}</h1>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
        <h1
          className={classNames(titleStyles, 'u-showBelowSM')}
          onClick={this.toggleGroupsList}
        >
          {title}
          <span className="PeopleHeader-titleTextArrow ">
            <Icon name="triangle_down" />
          </span>
        </h1>
        <PeopleHeaderButtons
          activeGroupCalculating={activeGroupCalculating}
          activeGroupRecalculationState={activeGroupRecalculationState}
          activeGroupId={activeGroupId}
          activeGroupType={activeGroupType}
          canEditSmartGroups={canEditSmartGroups}
          createNewRuleBasedGroup={createNewRuleBasedGroup}
          editRuleBasedGroup={editRuleBasedGroup}
          hasManagedGroups={hasManagedGroups}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  canEditSmartGroups: hasEditSmartGroupsPermissions(state),
  canManageAllGroups: hasPermission(state, 'manageAllGroups'),
  activeGroupId: state.filter.activeGroup,
  activeGroupCount: state.data.totalResults,
  activeGroupName: state.filter.activeGroup
    ? state.data.meta.groups[state.filter.activeGroup].name
    : null,
  activeGroupType: state.filter.activeGroup
    ? state.data.meta.groups[state.filter.activeGroup].type
    : null,
  activeGroupCalculating: state.filter.activeGroup
    ? state.data.meta.groups[state.filter.activeGroup].calculating
    : null,
  activeGroupRecalculationState: state.filter.activeGroup
    ? state.data.meta.groups[state.filter.activeGroup].recalculationState
    : null,
  isFetching: state.data.isFetching,
  currentUserRole: state.data.meta.currentUser.role,
});

export default connect(mapStateToProps)(PeopleHeader);
